import { useQuery } from '@apollo/client'
import { PromptResolve } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { RegularModal } from 'components'
import { DetectBlur } from 'containers/util-containers'
import { CLOSEST_CALENDAR_ITEMS } from './queries'
import styled from 'styled-components'
import { format, isSameDay } from 'date-fns'

const ClickableCalendarItem = styled.div`
  cursor: pointer;
  padding: 1rem;
  border-radius: 0.5rem;
  font-weight: 500;
  background-color: ${props => props.theme.colors.primary500};
  color: ${props => props.theme.colors.white};
  margin: 0.5rem 0;
  &:hover {
    background-color: ${props => props.theme.colors.primary300};
  }
`

interface AttachToCalendarItemModalProps {
  workPeriodId: string
  onSubmit: PromptResolve<{ id: string } | null>
}

export const AttachToCalendarItemModal: React.FC<
  AttachToCalendarItemModalProps
> = ({ workPeriodId, onSubmit }) => {
  const translations = useTranslate({
    selectCalendarItem: 'salary.select-calendar-item',
  })

  const { data } = useQuery(CLOSEST_CALENDAR_ITEMS, {
    variables: {
      workPeriodId,
    },
  })
  const calendarItems = data?.closestCalendarItemsToWorkPeriod || []

  return (
    <DetectBlur active onClickOutside={() => onSubmit(null)}>
      <RegularModal
        title={translations.selectCalendarItem}
        width="400px"
        onCancel={() => onSubmit(null)}
      >
        {calendarItems.map(item => {
          const start = new Date(item.start)
          const end = new Date(item.end)
          const sameDay = isSameDay(start, end)
          const dateString = sameDay
            ? `${format(start, 'd MMM HH:mm')} - ${format(end, 'HH:mm')}`
            : `${format(start, 'd MMM HH:mm')} - ${format(end, 'd MMM HH:mm')}`
          return (
            <ClickableCalendarItem
              key={item.id}
              onClick={evt => {
                evt.stopPropagation()
                evt.preventDefault()
                onSubmit(item)
              }}
            >
              <b>{item.title}:</b> {dateString}
            </ClickableCalendarItem>
          )
        })}
      </RegularModal>
    </DetectBlur>
  )
}
